import * as React from 'react';
import { createSvgIcon } from '@fluentui/react-icons-mdl2';

const PowerBILogo16Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M384 1143q27 0 50 11t41 29 27 42 10 51v306q0 27-9 51t-27 42-41 29-51 11q-27 0-50-10t-41-29-27-43-10-51v-306q0-27 9-51t27-42 41-29 51-11zm384-479q27 0 50 10t41 29 27 43 10 51v785q0 27-9 51t-27 42-41 29-51 11q-27 0-50-10t-41-29-27-43-10-51V797q0-27 9-51t27-42 41-29 51-11zm768-331q27 0 50 11t41 29 27 42 10 51v1112q0 27-9 51t-27 42-41 29-51 11q-27 0-50-10t-41-29-27-42-10-51V466q0-27 9-51t27-42 41-29 51-11zm-384 532q27 0 50 11t41 29 27 42 10 51v584q0 27-9 51t-27 42-41 29-51 11q-27 0-50-10t-41-29-27-43-10-51V998q0-27 10-51t27-42 40-29 51-11z" />
    </svg>
  ),
  displayName: 'PowerBILogo16Icon',
});

export default PowerBILogo16Icon;
